import styled from 'styled-components'
import { Dot } from './ProjectsStats.styled'
import { ColorDict } from './ProjectsStats.constant'

const Wrapper = styled.div`
  display: flex;
  gap: 16px;

  & > div {
    display: flex;
    justify-content: start;
    align-items: center;
    gap: 8px;

    font-size: 14px;
    font-weight: 400;
    color: #27272777;
  }
`

export const Legend = () => {
  return (
    <Wrapper>
    { Object.keys(ColorDict).map((k:string) => (
      <div key={k}>
        <Dot color={(ColorDict as any)[k]} />
        <div>{k}</div>
      </div>
    ))}
    </Wrapper>
  )
}
